<template>
    <v-dialog v-model="dialog" max-width="450">
        <template v-slot:activator="{ on }">
            <v-hover v-slot="{ hover }">
                <v-btn icon v-on="on" class="px-0" :class="{ 'red--text': hover }" :title="$t('Удаление привязки')">
                    <v-icon dense>mdi-delete</v-icon>
                </v-btn>
            </v-hover>
        </template>

        <v-card style="border-radius: 10px" class="pb-3">
            <div class="dialog-header"><v-spacer /><v-icon @click="dialog = false" class="mx-1 my-1 white--text">close</v-icon></div>
            <v-card-text>
                <center class="pt-4" style="font-size: 16px !important" v-html="message">{{ message }}</center>
            </v-card-text>
            <v-card-actions class="d-flex justify-center">
                <v-btn outlined @click="dialog = false" color="info" class="rounded-btn px-5 mr-4">{{ $t('Нет') }}</v-btn>

                <v-btn depressed color="info" @click="confirmDeletion()" class="rounded-btn px-6">{{ $t('Да') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import translate from '@/utils/translate.util';

export default {
    computed: {
        translatedDetails() {
            return translate(this.details, 'full', this.$i18n.locale);
        },
        message() {
            return `${this.$t('Вы подтверждаете удаление привязки')} <br/><br/>

                    ${this.translatedDetails.isas_address_full_name} - <br/> ${this.translatedDetails.isas_ksk_name} ?`;
        }
    },
    props: ['details'],
    data() {
        return {
            dialog: false
        };
    },
    methods: {
        async confirmDeletion() {
            this.dialog = false;
            this.$emit('deletionConfirmed');
        }
    }
};
</script>

<style>
.popup-btn {
    display: block;
    margin: auto;
}
</style>
